// © Microsoft Corporation. All rights reserved.
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Stack, PrimaryButton, Spinner } from '@fluentui/react';
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import {
	headerStyle,
	stackItemStyles,
	upperStackTokens,
	liststackItemStyles,
	buttonStyle,
	stackBtnItemStyles,
	upperStackStyle,
	upperStackButtons, dateTextStyle, dateInputStyle
} from './styles/HomeScreen.styles';
import { DisplayTextField } from './DisplayTextField';
// setLocale(locale.ko);
const mapDispatchToProps = (dispatch: any) => ({
});

const mapStateToProps = () => ({

});

export interface SceduleScreenProps {
	startCallHandler(): void;
}

const ScheduleMeetingScreen = (props: SceduleScreenProps): JSX.Element => {
	const headerTitle = 'Schedule a meeting';
	const spinnerLabel = 'Initializing schedule a meeting...';
	const scheduleButtonText = 'Submit';
	const [description, setDescription] = useState<string | undefined>('');
	const [dateTimeValue, setDateTimeValue] = useState<any | undefined>('');

	const [errorDesMsg, setDesErrorMsg] = useState<string | undefined>('');
	const buttonEnabled = description;
	// const [value, onChange] = useState('');
	useEffect(() => {
		getGroupIdFromUrl();
		getThreadFromUrl();
	}, [new URLSearchParams(window.location.search).get('groupId')]);

	const getGroupIdFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get('groupId');
	};

	const getThreadFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get('threadId');
	}
	const options = {
		enableTime: true,
		dateFormat: "d-m-Y h:i K",
		minuteIncrement: 30
	};
	const datepickerRef = React.createRef<Flatpickr>();
	return (
		<Fragment>
			<Stack>
				{(!getGroupIdFromUrl() && !getThreadFromUrl()) ? (
					<Fragment>
						<Stack.Item styles={stackItemStyles}>
							<div className={headerStyle}>{headerTitle}</div>
						</Stack.Item>
						<Stack.Item styles={stackItemStyles}>
							<Stack horizontal horizontalAlign="center" verticalAlign="start" className={upperStackStyle} tokens={upperStackTokens}>
								<Stack.Item styles={liststackItemStyles} className={dateInputStyle}>
									<p className={dateTextStyle} >Select date & time</p>
									{/* <DateTimePicker className={datePickerStyle} onChange={onChange} value={value} style={{ width: '100%' }} /> */}
									<Flatpickr
										placeholder="Select date & time"
										ref={datepickerRef}
										options={options}
										value={dateTimeValue}
										onChange={(date: any) => {
											// let selectedDate = date[0];
											// let currentDate = new Date();
											// let selectedDateWithCurrentTime = new Date(
											// 	selectedDate.setHours(
											// 		currentDate.getHours(),
											// 		currentDate.getMinutes(),
											// 		currentDate.getSeconds()
											// 	)
											// );
											// console.log(
											// 	"selectedDateWithCurrentTime",
											// 	selectedDateWithCurrentTime
											// );
											setDateTimeValue(date);
										}}
									/>
									<DisplayTextField
										type='textArea'
										errorMsg={errorDesMsg}
										setErrorMsg={setDesErrorMsg}
										defaultValue={description}
										setValue={setDescription}
										DISPLAY_NAME_MAX_CHARS={20}
										TEXTFIELD_LABEL={'Description'}
										TEXTFIELD_ID={'description'}
										TEXTFIELD_PLACEHOLDER={'Enter a description'}
										TEXTFIELD_EMPTY_ERROR_MSG={'Description cannot be empty'}
										required={true}
									/>
								</Stack.Item>
							</Stack>
						</Stack.Item>
						<Stack.Item styles={stackBtnItemStyles}>
							<Stack horizontal horizontalAlign="center" tokens={upperStackButtons}>
								<Stack.Item>
									<PrimaryButton className={buttonStyle} onClick={() => { props.startCallHandler(); }}>
										Back
									</PrimaryButton>
								</Stack.Item>
								<Stack.Item>
									<PrimaryButton disabled={!buttonEnabled} className={buttonStyle} onClick={() => {
										if (description) {
											props.startCallHandler();
										}
									}}>
										{scheduleButtonText}
									</PrimaryButton>
								</Stack.Item>
							</Stack>
						</Stack.Item>
					</Fragment>
				) : (
					<Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" />
				)
				}
			</Stack >
		</Fragment >
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleMeetingScreen);